/**
 * Deployed-version state (power#1224)
 *
 * `pendingVersion` is set by `useAppVersionWatcher` when the deployed
 * `version.json` reports a build different from the one this tab is running.
 * `NewVersionBanner` renders off it.
 *
 * There is no dismissal state by design: the banner is non-dismissible, so
 * there is nothing to persist and no snooze timer to get wrong.
 */

import { create } from "zustand";

interface AppVersionStore {
  /** Deployed build that differs from ours, or null while we are current. */
  pendingVersion: string | null;
  /** Deploy timestamp of the pending build (informational — never compared). */
  pendingBuiltAt: string | null;
  /** True from the moment the user clicks Reload until the document goes away. */
  isReloading: boolean;
  setPending: (version: string, builtAt: string | null) => void;
  clearPending: () => void;
  setReloading: (value: boolean) => void;
}

export const useAppVersionStore = create<AppVersionStore>((set) => ({
  pendingVersion: null,
  pendingBuiltAt: null,
  isReloading: false,

  setPending: (version, builtAt) =>
    set((state) =>
      state.pendingVersion === version
        ? state
        : { pendingVersion: version, pendingBuiltAt: builtAt },
    ),

  clearPending: () => set({ pendingVersion: null, pendingBuiltAt: null }),

  setReloading: (value) => set({ isReloading: value }),
}));
